(function () {
  'use strict';

  var coverRanges = [
    { size: 14, min: 23.0, max: 26.9 },
    { size: 15, min: 27.0, max: 28.9 },
    { size: 16, min: 29.0, max: 30.9 },
    { size: 17, min: 31.0, max: 32.6 },
    { size: 18, min: 32.7, max: 33.9 },
    { size: 19, min: 34.0, max: 36.0 },
    { size: 20, min: 36.1, max: 38.5 },
    { size: 21, min: 38.6, max: 40.6 }
  ];

  function cleanCode(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/×/g, 'X');
  }

  function buildResult(code, widthIn, sidewallIn, rim, diameterIn) {
    var circumferenceIn = Math.PI * diameterIn;

    return {
      code: code,
      widthIn: widthIn,
      sidewallIn: sidewallIn,
      rim: rim,
      diameterIn: diameterIn,
      circumferenceIn: circumferenceIn,
      revsPerMile: 63360 / circumferenceIn
    };
  }

  function parseTireCode(value) {
    var code = cleanCode(value);
    var metric = code.match(/^(?:P|LT|ST|T)?(\d{3})\/(\d{2,3})R?(\d{2}(?:\.\d)?)$/);
    var flotation = code.match(/^(\d{2}(?:\.\d+)?)X(\d{1,2}(?:\.\d+)?)R(\d{2}(?:\.\d)?)$/);
    var width;
    var ratio;
    var rim;
    var sidewallIn;
    var diameterIn;

    if (metric) {
      width = Number(metric[1]);
      ratio = Number(metric[2]);
      rim = Number(metric[3]);
      if (width < 100 || width > 500 || ratio < 20 || ratio > 100 || rim < 8 || rim > 30) return null;

      sidewallIn = width * (ratio / 100) / 25.4;
      diameterIn = rim + (2 * sidewallIn);
      return buildResult(code, width / 25.4, sidewallIn, rim, diameterIn);
    }

    if (flotation) {
      diameterIn = Number(flotation[1]);
      width = Number(flotation[2]);
      rim = Number(flotation[3]);
      if (diameterIn < 20 || diameterIn > 60 || width < 4 || width > 25 || rim < 8 || rim > 30 || diameterIn <= rim) return null;

      sidewallIn = (diameterIn - rim) / 2;
      return buildResult(code, width, sidewallIn, rim, diameterIn);
    }

    return null;
  }

  function recommendCover(diameter) {
    var rounded = Math.round(diameter * 10) / 10;
    for (var i = 0; i < coverRanges.length; i += 1) {
      if (rounded >= coverRanges[i].min && rounded <= coverRanges[i].max) return coverRanges[i];
    }
    return null;
  }

  function number(value, decimals) {
    return Number(value).toFixed(decimals);
  }

  function showMessage(element, text) {
    element.textContent = text;
    element.hidden = false;
  }

  function hideMessage(element) {
    element.textContent = '';
    element.hidden = true;
  }

  function updateMain(page, tire) {
    var recommendation = recommendCover(tire.diameterIn);
    var sizeOutput = page.querySelector('[data-tcp-cover-size]');
    var rangeOutput = page.querySelector('[data-tcp-cover-range]');
    var shopLink = page.querySelector('[data-tcp-shop-link]');
    var metricParts = tire.code.match(/^(?:P|LT|ST|T)?(\d{3})\/(\d{2,3})R?(\d{2}(?:\.\d)?)$/);
    var flotationParts = tire.code.match(/^(\d{2}(?:\.\d+)?)X(\d{1,2}(?:\.\d+)?)R(\d{2}(?:\.\d)?)$/);
    var codeA;
    var codeB;
    var codeC;
    var separator;
    var labelA;
    var labelB;

    if (metricParts) {
      codeA = metricParts[1];
      codeB = metricParts[2];
      codeC = metricParts[3];
      separator = '/';
      labelA = 'Tire width';
      labelB = 'Sidewall ratio';
    } else {
      codeA = flotationParts[1];
      codeB = flotationParts[2];
      codeC = flotationParts[3];
      separator = '×';
      labelA = 'Tire diameter';
      labelB = 'Tire width';
    }

    page.querySelector('[data-tcp-entered-size]').textContent = 'Optional recommendation for ' + tire.code;
    page.querySelector('[data-tcp-code-a]').textContent = codeA;
    page.querySelector('[data-tcp-code-b]').textContent = codeB;
    page.querySelector('[data-tcp-code-c]').textContent = codeC;
    page.querySelector('[data-tcp-code-separator]').textContent = separator;
    page.querySelector('[data-tcp-code-a-value]').textContent = codeA;
    page.querySelector('[data-tcp-code-b-value]').textContent = codeB;
    page.querySelector('[data-tcp-code-c-value]').textContent = codeC;
    page.querySelector('[data-tcp-code-a-label]').textContent = labelA;
    page.querySelector('[data-tcp-code-b-label]').textContent = labelB;
    page.querySelector('[data-tcp-diameter]').textContent = number(tire.diameterIn, 2) + ' inches';
    page.querySelector('[data-tcp-detail-diameter]').textContent = number(tire.diameterIn, 2) + ' in';
    page.querySelector('[data-tcp-sidewall]').textContent = number(tire.sidewallIn, 2) + ' in';
    page.querySelector('[data-tcp-circumference]').textContent = number(tire.circumferenceIn, 2) + ' in';
    page.querySelector('[data-tcp-revs]').textContent = String(Math.round(tire.revsPerMile));

    if (recommendation) {
      sizeOutput.textContent = recommendation.size;
      rangeOutput.textContent = 'This cover fits tire diameters from ' + recommendation.min.toFixed(1) + '" to ' + recommendation.max.toFixed(1) + '".';
      shopLink.textContent = 'Shop ' + recommendation.size + ' inch covers';
      shopLink.href = '/search?q=spare+tire+cover+' + recommendation.size + '+inch&type=product';
    } else {
      sizeOutput.textContent = '—';
      rangeOutput.textContent = 'This tire is outside our standard 14–21 inch cover range.';
      shopLink.textContent = 'Ask Nearkii for help';
      shopLink.href = '/pages/contact-us';
    }
  }

  function updateComparison(page, first, second) {
    var status = page.querySelector('[data-tcp-compare-status]');
    var difference = ((second.diameterIn - first.diameterIn) / first.diameterIn) * 100;
    var absoluteDifference = Math.abs(difference);
    var withinThreePercent = absoluteDifference <= 3;
    var actualSpeed = 60 * (second.diameterIn / first.diameterIn);

    status.classList.toggle('tcp-compare__status--warning', !withinThreePercent);
    page.querySelector('[data-tcp-compare-status-icon]').textContent = withinThreePercent ? '✓' : '!';
    page.querySelector('[data-tcp-compare-status-title]').textContent = withinThreePercent
      ? 'Diameter change is within 3%'
      : 'Diameter change is over 3%';
    page.querySelector('[data-tcp-compare-status-text]').textContent =
      'The new tire is ' + number(absoluteDifference, 1) + '% ' + (difference >= 0 ? 'larger.' : 'smaller.');
    page.querySelector('[data-tcp-compare-diameter-one]').textContent = number(first.diameterIn, 2) + ' in';
    page.querySelector('[data-tcp-compare-diameter-two]').textContent = number(second.diameterIn, 2) + ' in';
    page.querySelector('[data-tcp-actual-speed]').textContent = number(actualSpeed, 1) + ' mph actual';
  }

  function initPage(page) {
    if (page.getAttribute('data-initialized') === 'true') return;
    page.setAttribute('data-initialized', 'true');

    var form = page.querySelector('[data-tcp-form]');
    var input = page.querySelector('[data-tcp-size-code]');
    var message = page.querySelector('[data-tcp-message]');
    var compareForm = page.querySelector('[data-tcp-compare-form]');
    var compareOne = page.querySelector('[data-tcp-compare-one]');
    var compareTwo = page.querySelector('[data-tcp-compare-two]');
    var compareMessage = page.querySelector('[data-tcp-compare-message]');

    function calculateMain() {
      var tire = parseTireCode(input.value);
      if (!tire) {
        showMessage(message, 'Please enter a valid code, such as 255/70R18.');
        return;
      }

      hideMessage(message);
      input.value = tire.code;
      updateMain(page, tire);
    }

    function calculateComparison() {
      var first = parseTireCode(compareOne.value);
      var second = parseTireCode(compareTwo.value);
      if (!first || !second) {
        showMessage(compareMessage, 'Please enter two valid tire size codes.');
        return;
      }

      hideMessage(compareMessage);
      compareOne.value = first.code;
      compareTwo.value = second.code;
      updateComparison(page, first, second);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      calculateMain();
    });

    compareForm.addEventListener('submit', function (event) {
      event.preventDefault();
      calculateComparison();
    });

    page.querySelectorAll('[data-tcp-preset]').forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = button.getAttribute('data-tcp-preset');
        calculateMain();
      });
    });

    calculateMain();
    calculateComparison();
  }

  function initAll() {
    document.querySelectorAll('[data-tire-calculator-page]').forEach(initPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
}());
